import React from 'react';
import useStyle from './sidebar.style';

import { AccountSidbarUser } from '../../../../types/user/eleve.def';

import { BadgeAvatarSidebar } from '../../../molecules/Badges/BadgeAvatarSidebar';
import { AppVersionBlock } from '../../../molecules/Blocks/AppVersionBlock';

export interface SidebarViewProps {
  menu?: React.ReactElement;
  publicLayout?: boolean;
  user: AccountSidbarUser;
  goToDashboard: () => void;
  isMobile: boolean;
}

const SidebarView = ({
  menu,
  publicLayout,
  user,
  goToDashboard,
  isMobile
}: SidebarViewProps) => {
  const classes = useStyle();
  return (
    <nav className={classes.root}>
      <BadgeAvatarSidebar
        isMobile={isMobile}
        user={user}
        goToDashboard={goToDashboard}
        isRedirectToDashboard={publicLayout}
      />
      <div className={classes.content}>{menu}</div>
      <AppVersionBlock variant="normal" />
    </nav>
  );
};

export default SidebarView;
